import React, { useEffect, useState, useImperativeHandle, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import "./custom.scss";
import "./styles.scss";
import { initialData_out as initialData } from "./TableDataSet";
import update from "immutability-helper";
import Rows from "./DnDTables/DataTable";
import { TABLE_DATA } from "util"


const P_TYPE = "out";
const API = "/pcsCreate/retrieveParaOutList";
const HeaderTarget = {
    outReceivingSite: "Receiving Site",
    outSendingSite: "Sending Site",
    outTargetRange: "Target Range",
    outAcceptableRange: "Acceptable Range",
};

const OutTable = (props, _ref) => {
    const { so, sso, PROCode, autoResizeTextarea,onOpen,RevCmptCheckList } = props;
    const [Hide, setHide] = useState(false);

    const [TData, setTData] = useState([]);
    const [Header, SetHeader] = useState(HeaderTarget);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        loadData: ({ data, header }) => {
            let newVal = [];
            let tmparr;
            let tmp;
            let fidx;
            data.forEach((d) => {
                tmp = initialData;
                tmparr = [];
                d.forEach((dd) => {
                    Object.keys(dd).forEach((k) => {
                        fidx = tmp.findIndex((i) => i.name === k);
                        if (fidx > -1)
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: dd[k] } },
                            });
                        if (k === "samplePointNm") {
                            tmp = update(tmp, {
                                [fidx]: { $merge: { label: dd["samplePointNm"] } },
                            });
                        }
                        if (k === "rcvCritical") {
                            tmp = update(tmp, {
                                [fidx]: { $merge: { label: dd["rcvCriticalNm"] } },
                            });
                        }
                    });

                    tmparr = [...tmparr, ...[tmp]];
                });

                newVal = [...newVal, [...tmparr]];
            });
            setTData((DATA) => [...newVal]);
            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
    }));

    const onOpenWrapper = (vv,uniqueCode) => {
        if( vv.cmptCheck )
            onOpen(vv,uniqueCode,TData,'OUT');
    }
    const HandleHide = () => {
        setHide(!Hide);
    };

    useEffect(() => {
        document.querySelectorAll("textarea").forEach((e) => {
            autoResizeTextarea(e);
        });
    }, [TData]);

    const renderFunc = useMemo(() => {
        try {
            let _sso;
            if (sso > 0) {
                _sso = so[sso];
                let remark = _sso[P_TYPE + "Remark"];
                return (
                    <React.Fragment>
                        <tr>
                            <td 
                                colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                className="name">
                                    <div className={"namename"}>
                                        {_sso?.desc}
                                        {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                    </div>
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                    data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                    className="soremark"
                                >
                                    <div>{remark}</div>
                                </td>
                            </tr>
                        )}
                        {TData[sso - 1].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    PROCode={PROCode}
                                    code={_sso.code}
                                    index={ii}
                                    rowData={v}
                                    autoResizeTextarea={autoResizeTextarea}
                                    key={"out" + ii}
                                    onOpen = {onOpenWrapper}
                                    sheetType={"O"}
                                    RevCmptCheckList={RevCmptCheckList}
                                />
                            );
                        })}
                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {
                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i - 1].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2?.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];

                        if (chk.length > 0) {
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                            data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                            className="name"
                                        >
                                            <div className={"namename"}>
                                                {k.desc}
                                                {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                            </div>
                                        </td>
                                    </tr>
                                    {remark !== "FALSE" && (
                                        <tr>
                                            <td
                                                colSpan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                                data-colspan={Object.keys(initialData.filter(x=>(x.type !== 'hidden' &&  x.name !== 'hide'))).length}
                                                className="soremark"
                                            >
                                                <div>{remark}</div>
                                            </td>
                                        </tr>
                                    )}
                                    {TData[i - 1].map((v, ii) => {
                                        return (
                                            <Rows
                                                api={API}
                                                PROCode={PROCode}
                                                code={k.code}
                                                index={ii}
                                                rowData={v}
                                                autoResizeTextarea={autoResizeTextarea}
                                                key={"out" + ii}
                                                onOpen = {onOpenWrapper}
                                                dataIndex={i}
                                                sheetType={"O"}
                                                RevCmptCheckList={RevCmptCheckList}
                                            />
                                        );
                                    })}
                                </React.Fragment>
                            );
                        } else {
                            return null;
                        }
                    } catch (e) {
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            return null;
        }
    }, [TData, so, sso, RevCmptCheckList]);

    return (
        <section className="detail">
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                Performance Parameter <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table "}>
                    <table className="bpl-table-default">
                        {TABLE_DATA?.header?.[P_TYPE](Header, true)}
                        <tbody>{renderFunc}</tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default React.memo(React.forwardRef(OutTable));
